// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:23:08

export default {
  "id": "space-blast-1",
  "slug": "space-blast-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/84306950ffed41d5a7c05093e0092e84-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/84306950ffed41d5a7c05093e0092e84/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Space Blast",
      "description": "Space Blast is a 2D game full of action arcade game where your piloting skills and strategic thinking are key to navigating relentless waves of meteors. Command a powerful spaceship equipped with advanced weapons and take on the challenge of protecting the galaxy from incoming threats.",
      "instructions": "\nShoot the planets and upgrade your weapon",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "airplane",
        "space"
      ]
    },
    "zh-CN": {
      "title": "太空冲击",
      "description": "太空爆破是一款充满动作街机元素的2D游戏，你的驾驶技巧和战略思维对于穿梭在连绵不绝的流星雨中至关重要。指挥一艘装备了先进武器的强大宇宙飞船，挑战保护银河系免受来犯威胁的挑战。",
      "instructions": "射击行星并升级你的武器",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "飞机",
        "太空"
      ]
    },
    "zh-TW": {
      "title": "太空爆破",
      "description": "太空爆破是一個充滿動作街機遊戲的2D遊戲，你的駕駛技巧和策略思考是導航無情流星狂潮的關鍵。指揮一艘裝備先進武器的強大太空船，接受保護銀河免受來襲威脅的挑戰。",
      "instructions": "射擊行星並升級你的武器",
      "genres": [
        "射手"
      ],
      "tags": [
        "飛機",
        "太空"
      ]
    },
    "zh-HK": {
      "title": "太空爆破",
      "description": "太空爆破是一個充滿動作街機遊戲的2D遊戲，你的駕駛技巧和策略思考是駕馭無敵流星雨關鍵。指揮一艘裝備先進武器的強大太空船，接受挑戰，保護銀河不受來襲威脅。",
      "instructions": "射擊行星並升級你的武器",
      "genres": [
        "射手"
      ],
      "tags": [
        "飛機",
        "太空"
      ]
    },
    "ja": {
      "title": "スペースブラスト",
      "description": "スペースブラストは、パイロティングスキルと戦略的な思考が、無慈悲な隕石の波を進む鍵となるアクションアーケードゲームです。高度な武器を装備した強力な宇宙船を指揮し、銀河を襲う脅威から守る挑戦に挑みましょう。",
      "instructions": "惑星を撃ち、武器をアップグレードして吧",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "飛行機",
        "宇宙"
      ]
    },
    "ko": {
      "title": "우주폭발",
      "description": "스페이스 블라스트는 piloting skills과 strategic thinking이 중요한 2D 액션 아케이드 게임입니다. 끊임없는meteor의 공격을 막기 위해 강력한 무장된 우주선을 조종하고,銀河를 공격하는 تهديد로부터 보호하는 도전을 맞습니다.",
      "instructions": "행성을 쏘아서 무기를 업그레이드하세요",
      "genres": [
        "슈터"
      ],
      "tags": [
        "비행기",
        "우주"
      ]
    },
    "fr": {
      "title": "Explosion Spatiale",
      "description": "Space Blast est un jeu 2D d'action arcade où vos compétences en pilotage et votre pensée stratégique sont essentielles pour naviguer à travers des vagues sans fin de météores. Commandez une navette spatiale puissante équipée d'armes avancées et affrontez le défi de protéger la galaxie contre les menaces approchantes.",
      "instructions": "Tirez sur les planètes et mettez à niveau votre arme",
      "genres": [
        "Tirailleur"
      ],
      "tags": [
        "avion",
        "espace"
      ]
    }
  }
};
